import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';

import { AlertService } from 'src/app/services';
import { AlarmRepo } from 'src/app/repositories/alarm-repo';
import { AlarmStateFrench } from 'src/app/shared/models/alarm/alarm-filter';
import { AlertParameters, AlertType } from 'src/app/shared/models/models-index';

import { AlarmRealTime, AlarmState } from 'src/swagger-gen/web-secured/models';


@Component({
    selector: 'app-alarm',
    templateUrl: './alarm.component.html',
    styleUrls: ['./alarm.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlarmComponent implements OnInit, OnDestroy {

  @Input() alarm: AlarmRealTime;

  alarmStates = AlarmState;
  alarmStateFrench = AlarmStateFrench; // translation

  /** True while doing action on an alarm (during call to BE) */
  changingStatus = false;
  /**
   * Current application language
   */
  language: 'fr' | 'en' = 'fr';

  /**
   * Date format to display depending of language
   */
  dateFormat: string;

  showButton = false;

  private subscriptions: Subscription[] = [];

  constructor(private logger: NGXLogger,
              private alarmsService: AlarmRepo,
              public alertService: AlertService) { }

  ngOnInit() {
    this.setDateFormat();
  }

  /**
   * Set the date format depending on the language
   */
  setDateFormat() {
    if (this.language === 'fr') {
      this.dateFormat = 'dd/MM/yyyy HH:mm:ss';
    } else {
      this.dateFormat = 'MM/dd/yyyy HH:mm:ss';
    }
  }

  /**
   *  Bouton 'ACQUITTER'
   */
  // acknowledgeAlarm(alarmUid: string) {
  //   this.changingStatus = true;
  //   this.subscriptions.push(
  //     this.alarmsService.acknowledgeAlarm(alarmUid).subscribe({
  //       next: (response) => {
  //         this.logger.log(`Acknowledged Alarm ${alarmUid}: ${response}`);
  //         this.changingStatus = false;
  //         this.alarm.state = AlarmState.RAISED_ACKNOWLEDGED;
  //       },
  //       error: (error: any) =>  {
  //         this.changingStatus = false;
  //         this.logger.error(error);
  //         const alertParams = new AlertParameters(false, false, true, false, false, false, true, 'Erreur d\'acquittement d\'alarme');
  //         // Could not acknowledge alarm
  //         this.alertService.showAlert(error, AlertType.ERROR, alertParams);
  //       }
  //     })
  //   );
  // }

  /**
   * Bouton 'RETABLIR'
   */
  // reactivateAlarm(alarmUid: string) {
  //   this.changingStatus = true;
  //   this.subscriptions.push(
  //     // TODO: replace with correct API call
  //     this.alarmsService.restoreAlarm(alarmUid).subscribe({
  //       next: (response) => {
  //         this.logger.trace(`Reactivated Alarm ${alarmUid}: ${response}`);
  //         this.changingStatus = false;
  //         this.alarm.state = AlarmState.RAISED;
  //       },
  //       error: (error: any) =>  {
  //         this.changingStatus = false;
  //         this.logger.error(error);
  //         const alertParams = new AlertParameters(false, false, true, false, false, false, true, 'Erreur de rétablissement d\'alarme');
  //         // 'Could not reactivate alarm'
  //         this.alertService.showAlert(error, AlertType.ERROR, alertParams);
  //       }
  //     })
  //   );
  // }

  ngOnDestroy() {
    if (this.subscriptions !== undefined) {
      this.subscriptions.forEach((s) => s.unsubscribe());
    }
  }
}
